if (!customElements.get("vt-filter-model")) {
  class FilterModal extends HTMLElement {
    constructor() {
      super();
      this.element = this;
      this.yearSelect = this.querySelector(".js-year-selects");
      this.makeSelect = this.querySelector(".js-make-selects");
      this.modelSelect = this.querySelector(".js-model-selects");
      this.bodySelect = this.querySelector(".js-body-selects");
      this.bodyParent = this.bodySelect?.parentElement;
      this.submitBtn = this.querySelector(".js-submit");
      this.currentSelectedCarWrapper = document.querySelectorAll(
        ".js-selected-car-wrapper"
      );
      this.currentSelectedCars = document.querySelectorAll(
        ".js-current-selected-car"
      );
      this.collectionHeroTitle = document.querySelector(".js-collection-hero-title");
      this.pathname = window.location.pathname;
      this.filterModal = document.querySelector(".js-filter-modal");
      this.carChangeBtns = document.querySelectorAll(".js-car-change");
      this.closeModalBtn = document.querySelector(".js-close-filer-modal");
      this.isApplyingSelections = false; // Flag để tránh vòng lặp
      this.hasAppliedSelections = false; // Flag để đảm bảo chỉ apply một lần
      this.isSettingValueProgrammatically = false; // Flag để tránh trigger event khi set value programmatically
      this.productClickHandlerBound = false; // Flag để tránh bind duplicate event listeners
      this.bindEventsCalled = false; // Flag để tránh gọi bindEvents nhiều lần
      this.setDefaultSelectionsCalled = false; // Flag để tránh gọi setDefaultSelectionsFromURLOrStorage nhiều lần
      this.bindEvents();
    }

    bindEvents() {
      // Đợi YMM_DATA load xong trước khi thực hiện bất kỳ thao tác nào
      this.waitForYMMData(() => {
        this.populateYears();
        this.setDefaultSelectionsFromURLOrStorage();

        this.handleShowAllMake();
        this.updateFakeBreadcrumb();
        this.renderMakeCategories();

        this.yearSelect.addEventListener("change", this.onYearChange.bind(this));
        this.makeSelect.addEventListener("change", this.onMakeChange.bind(this));
        this.modelSelect.addEventListener("change", (e) =>
          this.onModelChange(e, true)
        );
        this.bodySelect.addEventListener("change", this.toggleSubmit.bind(this));
        this.submitBtn.addEventListener("click", this.onSubmit.bind(this));

        if (this.element.dataset.page === "product") this.handleProductPage();
        if (this.element.dataset.page === "collection") this.handleCollections();
        this.openModal();
        this.closeModal();
      });
    }

    // Helper function để đợi YMM_DATA load xong
    waitForYMMData(callback, maxAttempts = 100, attempt = 0) {
      if (typeof YMM_DATA !== 'undefined' && YMM_DATA && Object.keys(YMM_DATA).length > 0) {
        callback();
        return;
      }

      if (attempt >= maxAttempts) {
        console.error("[waitForYMMData] YMM_DATA not available after max attempts. Some features may not work correctly.");
        // Vẫn gọi callback để không block UI, nhưng log warning
        callback();
        return;
      }

      // Retry sau 200ms
      setTimeout(() => {
        this.waitForYMMData(callback, maxAttempts, attempt + 1);
      }, 200);
    }

    populateYears() {
      // Đảm bảo YMM_DATA đã load
      if (typeof YMM_DATA === 'undefined' || !YMM_DATA || Object.keys(YMM_DATA).length === 0) {
        console.warn("[populateYears] YMM_DATA not available");
        return;
      }

      this.yearSelect.innerHTML = `<option value="">Select Year</option>`;
      Object.keys(YMM_DATA)
        .map((year) => Number(year))
        .sort((a, b) => b - a)
        .forEach((year) => {
          this.yearSelect.innerHTML += `<option value="${year}">${year}</option>`;
        });

      this.makeSelect.disabled = true;
    }

    handleShowAllMake() {
      const trigger = document.querySelector(".js-fake-make");
      if (!trigger) return;
      trigger.addEventListener("click", () => {
        const baseHref = trigger.dataset.href;
        const make = trigger.textContent.trim();
        if (!baseHref || !make) return;

        const newUrl = `${baseHref}?make=${encodeURIComponent(make)}`;
        window.location.href = newUrl;
      });
    }

    openModal() {
      if (!this.filterModal) return;
      this.carChangeBtns?.forEach((btn) => {
        btn.addEventListener("click", () => {
          const selects = this.filterModal.querySelectorAll("select");
          selects.forEach((select) => {
            select.value = "";
          });
          this.filterModal.classList.add("open");
        });
      });
    }

    // =========================
    // MAIN RENDER FUNCTION
    // =========================
    renderMakeCategories() {
      const categoriesList = document.querySelector(".js-categories-list");
      const template = document.querySelector(".js-products-categories");
      const collections = document.querySelector(".js-main-collection");
      const hiddenItems = document.querySelectorAll(".js-hidden-item");

      if (!categoriesList || !template) return;

      // ----------------------
      // XỬ LÝ URL
      // ----------------------
      let pathParts = window.location.pathname.split("/").filter(Boolean);
      let savedVehicle = null;

      try {
        const saved = localStorage.getItem("vehicleInfo");
        if (saved) savedVehicle = JSON.parse(saved);
      } catch (err) {
        console.warn("[renderMakeCategories] Invalid vehicleInfo in localStorage");
      }

      const isVehiclePath =
        pathParts.length > 0 &&
        pathParts[0] !== "collections" &&
        pathParts[0] !== "products" &&
        pathParts[0] !== "pages";

      if (!isVehiclePath && savedVehicle?.make) {
        pathParts = [this.slugify(savedVehicle.make)];
        if (savedVehicle.model) pathParts.push(this.slugify(savedVehicle.model));
        if (savedVehicle.year) pathParts.push(String(savedVehicle.year));
        if (savedVehicle.body) pathParts.push(this.slugify(savedVehicle.body));
      }

      // Check if this is a type-only collection (e.g., /collections/truck-covers)
      const isTypeOnlyCollection = pathParts.length === 2 && 
        pathParts[0] === "collections" && 
        pathParts[1].endsWith("-covers");

      // If type-only collection, don't hide main collection and don't render categories
      if (isTypeOnlyCollection) {
        if (collections) collections.classList.remove("vt-hidden");
        categoriesList.classList.add("vt-hidden");
        return;
      }

      let [make, model, year, body] = pathParts;

      // Convert slug → text thực
      if (model) model = this.unslugify(model);
      if (body) body = this.unslugify(body);

      // Nếu đã đi đến Level 4 thì không render nữa
      if (pathParts.length >= 4) {
        categoriesList.classList.add("vt-hidden");
        if (collections) collections.classList.remove("vt-hidden");
        return;
      }

      // Ẩn collection gốc chỉ khi đang ở vehicle-specific path
      if (collections) collections.classList.add("vt-hidden");
      hiddenItems.forEach((e) => e.classList.add("vt-hidden"));

      // Xóa list và hiện lại
      categoriesList.innerHTML = "";
      categoriesList.classList.remove("vt-hidden");

      // ======================================================
      // 🚦 LEVEL 1 → MAKE → RENDER MODEL LIST
      // ======================================================
      if (pathParts.length === 1) {
        const models = this.getModelsByMake(make);

        // Sort models alphabetically by model name
        models.sort((a, b) => {
          const nameA = this.capitalize(a.model).toLowerCase();
          const nameB = this.capitalize(b.model).toLowerCase();
          return nameA.localeCompare(nameB);
        });

        models.forEach(({ model }) => {
          const clone = template.content
            .querySelector(".js-categories-item")
            .cloneNode(true);

          const linkEl = clone.querySelector("a");
          const url = `/${make}/${this.slugify(model)}`;

          linkEl.href = url;
          linkEl.textContent = `${this.capitalize(make)} ${this.capitalize(model)}`;
          linkEl.dataset.make = make;
          linkEl.dataset.model = model;

          categoriesList.appendChild(clone);
        });

        this.bindCategoriesClick();
        return;
      }

      // ======================================================
      // 🚦 LEVEL 2 → MAKE + MODEL → RENDER YEAR LIST
      // ======================================================
      if (pathParts.length === 2) {
        const years = this.getYearsByMakeModel(make, model);

        years.forEach((yearNum) => {
          const clone = template.content
            .querySelector(".js-categories-item")
            .cloneNode(true);

          const linkEl = clone.querySelector("a");
          const url = `/${make}/${this.slugify(model)}/${yearNum}`;

          linkEl.href = url;
          linkEl.textContent = `${yearNum} ${this.capitalize(model)}`;
          linkEl.dataset.year = yearNum;

          categoriesList.appendChild(clone);
        });

        this.bindCategoriesClick();
        return;
      }

      // ======================================================
      // 🚦 LEVEL 3 → MAKE + MODEL + YEAR → RENDER BODY LIST
      // ======================================================
      if (pathParts.length === 3) {
        const bodies = this.getBodiesByMakeModelYear(make, model, year);

        // Nếu KHÔNG CÓ BODY → show collections luôn
        if (!bodies || bodies.length === 0) {
          categoriesList.classList.add("vt-hidden"); // ẩn menu
          document
            .querySelector(".js-main-collection")
            ?.classList.remove("vt-hidden");
          return;
        }

        // Collect all body names (including split by comma)
        const allBodyNames = [];
        bodies.forEach((bodyName) => {
          const childBodies = bodyName.split(",").map((b) => b.trim());
          childBodies.forEach((b) => {
            if (b.length > 0) {
              allBodyNames.push(b);
            }
          });
        });

        // Sort bodies alphabetically
        allBodyNames.sort((a, b) => {
          const nameA = this.capitalize(a).toLowerCase();
          const nameB = this.capitalize(b).toLowerCase();
          return nameA.localeCompare(nameB);
        });

        // Render sorted bodies
        allBodyNames.forEach((bodyName) => {
          const clone = template.content
            .querySelector(".js-categories-item")
            .cloneNode(true);

          const linkEl = clone.querySelector("a");
          const url = `/${make}/${this.slugify(model)}/${year}/${this.slugify(bodyName)}`;

          linkEl.href = url;
          linkEl.textContent = `${this.capitalize(make)} ${this.capitalize(model)} ${year} - ${this.capitalize(bodyName)}`;
          linkEl.dataset.body = bodyName;

          categoriesList.appendChild(clone);
        });

        this.bindCategoriesClick();
        return;
      }
    }

    //
    // ===============================
    // HELPER FUNCTIONS
    // ===============================
    //

    capitalize(str) {
      if (!str) return "";
      // Capitalize first letter of each word (Title Case)
      return str
        .toLowerCase()
        .split(" ")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
    }

    // Convert slug → text thật
    unslugify(str) {
      return str.replace(/-/g, " ").replace(/\s+/g, " ").trim();
    }

    // Convert text → slug
    slugify(str) {
      return str
        .toLowerCase()
        .replace(/\s+/g, "-")
        .replace(/[^a-z0-9\-]/g, "");
    }

    // Lấy danh sách model theo MAKE
    getModelsByMake(make) {
      if (typeof YMM_DATA === 'undefined' || !YMM_DATA || Object.keys(YMM_DATA).length === 0) {
        return [];
      }

      const models = new Set();

      Object.keys(YMM_DATA).forEach((year) => {
        const makeKey = this.findKeyLoose(YMM_DATA[year], make);
        if (!makeKey) return;
        const makeObj = YMM_DATA[year][makeKey];
        if (makeObj) {
          Object.keys(makeObj).forEach((model) => models.add(model));
        }
      });

      return [...models].map((model) => ({ model }));
    }

    getYearsByMakeModel(make, model) {
      if (typeof YMM_DATA === 'undefined' || !YMM_DATA || Object.keys(YMM_DATA).length === 0) {
        console.warn("[getYearsByMakeModel] YMM_DATA not available");
        return [];
      }

      const years = [];

      Object.keys(YMM_DATA).forEach((yearKey) => {
        const makes = YMM_DATA[yearKey];

        // tìm make dạng include
        const makeKey = this.findKeyLoose(makes, make);
        if (!makeKey) return;

        const models = makes[makeKey];

        // tìm model dạng include
        const modelKey = this.findKeyLoose(models, model);
        if (!modelKey) return;

        years.push(Number(yearKey));
      });

      return years.sort((a, b) => b - a);
    }

    getBodiesByMakeModelYear(make, model, year) {
      if (typeof YMM_DATA === 'undefined' || !YMM_DATA || Object.keys(YMM_DATA).length === 0) {
        console.warn("[getBodiesByMakeModelYear] YMM_DATA not available");
        return [];
      }

      const makes = YMM_DATA[year];
      if (!makes) return [];

      const makeKey = this.findKeyLoose(makes, make);
      if (!makeKey) return [];

      const models = makes[makeKey];
      const modelKey = this.findKeyLoose(models, model);
      if (!modelKey) return [];

      const modelObj = models[modelKey];
      if (!modelObj || !modelObj.body) return [];

      const body = modelObj.body;

      return Array.isArray(body) ? body : [body];
    }

    normalize(str) {
      return str
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, " ") // bỏ ký tự đặc biệt
        .replace(/\s+/g, " ") // gom space
        .trim();
    }

    findKeyLoose(obj, target) {
      if (!obj) return null;

      const t = this.normalize(target);

      for (const key of Object.keys(obj)) {
        const k = this.normalize(key);
        if (k.includes(t) || t.includes(k)) {
          return key; // trả về key gốc trong YMM_DATA
        }
      }

      return null;
    }

    capitalizeMake(str) {
      return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    }

    bindCategoriesClick() {
      const items = document.querySelectorAll(".js-categories-item a");
      items.forEach((linkEl) => {
        linkEl.addEventListener("click", (e) => {
          e.preventDefault();

          const vehicleInfo = {
            year: linkEl.dataset.year,
            make: linkEl.dataset.make,
            model: linkEl.dataset.model,
            body: linkEl.dataset.body,
            type: linkEl.dataset.type,
          };

          localStorage.setItem("vehicleInfo", JSON.stringify(vehicleInfo));
          window.location.href = linkEl.href;
        });
      });
    }

    bindProductClickToClearStorage() {
      // Kiểm tra xem có phải là type-only collection không
      const pathParts = window.location.pathname.split("/").filter(Boolean);
      const isTypeOnlyCollection = pathParts.length === 2 && 
        pathParts[0] === "collections" && 
        pathParts[1].endsWith("-covers");
      
      // Lấy type từ URL nếu là type-only collection
      let typeToSave = null;
      if (isTypeOnlyCollection) {
        const typeSlug = pathParts[1].replace("-covers", "");
        typeToSave = this.capitalize(typeSlug.replace(/-/g, " "));
      }
      
      // Sử dụng event delegation để handle cả dynamic content
      // Sử dụng một flag để tránh duplicate event listeners
      if (this.productClickHandlerBound) {
        return; // Đã bind rồi, không bind lại
      }
      
      const handleProductClick = (e) => {
        // Tìm thẻ a trong .js-collections-heading hoặc .js-collections-heading chính là thẻ a
        let linkEl = null;
        let headingEl = null;
        
        // Kiểm tra xem target có phải là .js-collections-heading không
        if (e.target.classList.contains('js-collections-heading')) {
          headingEl = e.target;
          linkEl = e.target.tagName === 'A' ? e.target : e.target.querySelector('a');
        } else {
          // Tìm .js-collections-heading gần nhất
          headingEl = e.target.closest('.js-collections-heading');
          if (headingEl) {
            linkEl = headingEl.tagName === 'A' ? headingEl : headingEl.querySelector('a');
          } else {
            // Fallback: tìm thẻ a có href chứa /products/
            linkEl = e.target.closest('a[href*="/products/"]');
          }
        }
        
        // Kiểm tra xem có phải là product link không
        if (!linkEl || !linkEl.href || !linkEl.href.includes('/products/')) {
          return;
        }
        
        // Kiểm tra lại xem có phải là type-only collection không (có thể URL đã thay đổi)
        const currentPathParts = window.location.pathname.split("/").filter(Boolean);
        const currentIsTypeOnlyCollection = currentPathParts.length === 2 && 
          currentPathParts[0] === "collections" && 
          currentPathParts[1].endsWith("-covers");
        
        if (currentIsTypeOnlyCollection) {
          // Nếu là type-only collection, lấy type từ URL và lưu vào localStorage
          const currentTypeSlug = currentPathParts[1].replace("-covers", "");
          const currentType = this.capitalize(currentTypeSlug.replace(/-/g, " "));
          localStorage.setItem("vehicleInfo", JSON.stringify({ type: currentType }));
        } else if (isTypeOnlyCollection && typeToSave) {
          // Fallback: sử dụng type đã lấy trước đó
          localStorage.setItem("vehicleInfo", JSON.stringify({ type: typeToSave }));
        } else {
          // Clear vehicle info when clicking product (trường hợp bình thường)
          localStorage.removeItem("vehicleInfo");
        }
      };
      
      // Bind event delegation trên document để catch tất cả clicks
      // Sử dụng capture phase để catch sớm hơn và stop propagation
      document.addEventListener('click', handleProductClick, true);
      this.productClickHandlerBound = true;
      
      // Cũng bind trực tiếp cho các links hiện có
      const headings = document.querySelectorAll(".js-collections-heading");
      
      headings.forEach((headingEl) => {
        // Tìm thẻ a trong heading (có thể heading chính là thẻ a hoặc chứa thẻ a)
        const linkEl = headingEl.tagName === 'A' ? headingEl : headingEl.querySelector('a');
        
        if (!linkEl) return;
        
        // Skip if already bound
        if (linkEl.dataset.vtStorageCleared === "true") return;
        
        linkEl.dataset.vtStorageCleared = "true";
        linkEl.addEventListener("click", (e) => {
          // Kiểm tra lại xem có phải là type-only collection không
          const currentPathParts = window.location.pathname.split("/").filter(Boolean);
          const currentIsTypeOnlyCollection = currentPathParts.length === 2 && 
            currentPathParts[0] === "collections" && 
            currentPathParts[1].endsWith("-covers");
          
          if (currentIsTypeOnlyCollection) {
            // Nếu là type-only collection, lấy type từ URL và lưu vào localStorage
            const currentTypeSlug = currentPathParts[1].replace("-covers", "");
            const currentType = this.capitalize(currentTypeSlug.replace(/-/g, " "));
            localStorage.setItem("vehicleInfo", JSON.stringify({ type: currentType }));
          } else if (isTypeOnlyCollection && typeToSave) {
            // Fallback: sử dụng type đã lấy trước đó
            localStorage.setItem("vehicleInfo", JSON.stringify({ type: typeToSave }));
          } else {
            // Clear vehicle info when clicking product (trường hợp bình thường)
            localStorage.removeItem("vehicleInfo");
          }
        }, true); // Use capture phase để chạy trước các event listener khác
      });
    }

    closeModal() {
      if (!this.filterModal) return;
      this.closeModalBtn.addEventListener("click", () => {
        this.filterModal.classList.remove("open");
      });
    }

    updateFakeBreadcrumb() {
      const fakeBreadcrumb = document.querySelector(".js-fake-breadcrumb");
      const makeEl = document.querySelector(".js-fake-make");
      const productEl = document.querySelector(".js-fake-product");
      const page = fakeBreadcrumb.dataset.page;

      if (!makeEl || !productEl) {
        fakeBreadcrumb.classList.add("hidden");
        return;
      } else {
        fakeBreadcrumb.classList.remove("hidden");
      }

      const pathParts = window.location.pathname.split("/").filter(Boolean);
      let [make, model, year, body] = pathParts
        .slice(-4)
        .map(decodeURIComponent);
      if (pathParts.length === 3) {
        [make, model, year] = pathParts.slice(-3).map(decodeURIComponent);
      }

      if (!(year && make && model)) {
        const saved = localStorage.getItem("vehicleInfo");
        if (saved) {
          try {
            const parsed = JSON.parse(saved);
            year = year || parsed.year;
            make = make || parsed.make;
            model = model || parsed.model;
            body = body || parsed.body;
          } catch (err) {
            console.warn("Invalid vehicleInfo in localStorage");
          }
        }
      }

      if (page === "product") {
        const urlParams = new URLSearchParams(window.location.search);
        year = urlParams.get("year") || year;
        make = urlParams.get("make") || make;
        model = urlParams.get("model") || model;
        body = urlParams.get("body") || body;
      }

      if (pathParts[0] === "collections" || pathParts[0] === "products") {
        productEl.innerHTML = this.capitalize(pathParts[1]);
      }

      if (!(year && make && model)) return;

      const formatText = (str) =>
        str
          .replace(/-/g, " ")
          .replace(/\s+/g, " ")
          // Thêm khoảng trắng giữa chữ và số (ví dụ: "Bed8" -> "Bed 8")
          .replace(/([a-zA-Z])(\d)/g, "$1 $2")
          // Thêm khoảng trắng giữa số và chữ (ví dụ: "8Ft" -> "8 Ft")
          .replace(/(\d)([a-zA-Z])/g, "$1 $2")
          .trim()
          .replace(/\b\w/g, (c) => c.toUpperCase());

      make = formatText(make);
      model = formatText(model);
      if (body) body = formatText(body);

      makeEl.textContent = make;
      makeEl.setAttribute("href", `/collections/${make.toLowerCase()}`);

      if (page === "product") {
        makeEl.classList.add("hidden");
        makeEl.nextElementSibling.classList.add("hidden");
        const productNameParts = [year, make, model];
        if (body) productNameParts.push(`(${body})`);
        productEl.textContent = productNameParts.join(" ");
      } else {
        const productNameParts = [year, make, model];
        if (body) productNameParts.push(`(${body})`);
        productEl.textContent = productNameParts.join(" ");
      }
    }

    setDefaultSelectionsFromURLOrStorage() {
      // Tránh gọi nhiều lần
      if (this.setDefaultSelectionsCalled) {
        return;
      }
      this.setDefaultSelectionsCalled = true;
      
      const pathParts = window.location.pathname.split("/").filter(Boolean);
      const currentPage = this.element.dataset.page;

      // ✅ Nếu currentPage === "page" → chỉ lấy dữ liệu từ localStorage
      if (currentPage === "page") {
        const saved = localStorage.getItem("vehicleInfo");
        if (saved) {
          try {
            const parsed = JSON.parse(saved);
            const { year, make, model, body, type } = parsed;
            if (year && make && model) {
              this.applySelections({ year, make, model, body, type });
            }
          } catch (err) {
            console.warn("Invalid vehicleInfo in localStorage");
          }
        }
        return;
      }

      // 🔹 Xử lý type-only collections (ví dụ: /collections/car-covers)
      const isTypeOnlyCollection = pathParts.length === 2 && 
        pathParts[0] === "collections" && 
        pathParts[1].endsWith("-covers");
      
      if (isTypeOnlyCollection) {
        // Extract type từ URL (ví dụ: "car-covers" -> "Car")
        const typeSlug = pathParts[1].replace("-covers", "");
        const type = this.capitalize(typeSlug.replace(/-/g, " "));
        
        // Lưu type vào localStorage
        localStorage.setItem("vehicleInfo", JSON.stringify({ type }));
        
        // Update collection hero title
        this.updateCollectionHeroTitle({ type });
        
        return;
      }

      // 🔹 Xử lý URL path theo từng bước
      // Kiểm tra xem có phải là vehicle path không (không phải /collections, /products, /pages)
      const isVehiclePath = pathParts.length > 0 && 
          pathParts[0] !== "collections" && 
          pathParts[0] !== "products" && 
          pathParts[0] !== "pages";
      
      // Nếu không phải vehicle path, kiểm tra localStorage và apply nếu có đầy đủ dữ liệu
      if (!isVehiclePath) {
        const saved = localStorage.getItem("vehicleInfo");
        if (saved) {
          try {
            const parsed = JSON.parse(saved);
            const { year, make, model, body, type } = parsed;
            // Nếu có đầy đủ year, make, model trong localStorage, apply selections
            if (year && make && model) {
              // Reset flag để cho phép apply lại
              this.hasAppliedSelections = null;
              this.isApplyingSelections = false;
              // Đợi YMM_DATA load xong trước khi apply
              this.waitForYMMData(() => {
                this.applySelections({ year, make, model, body, type });
              });
            }
          } catch (err) {
            console.warn("Invalid vehicleInfo in localStorage");
          }
        }
        return;
      }

      // Lấy dữ liệu từ URL path
      let make = pathParts[0] || null;
      let model = pathParts[1] || null;
      let year = pathParts[2] || null;
      let body = pathParts[3] || null;

      // Format make/model từ slugs
      // Ví dụ: "model-16" -> "Model 16", "buick" -> "Buick"
      if (make) {
        make = this.normalizeKeyFromHandle(make);
      }
      if (model) {
        // Unslugify trước để xử lý các trường hợp như "model-16"
        model = this.unslugify(model);
        // Sau đó normalize để đảm bảo format đúng
        model = this.normalizeKeyFromHandle(model);
      }
      if (body) {
        body = this.normalizeKeyFromHandle(body);
      }

      // Lấy dữ liệu cũ từ localStorage để merge
      const saved = localStorage.getItem("vehicleInfo");
      let savedData = {};
      if (saved) {
        try {
          savedData = JSON.parse(saved);
        } catch (err) {
          console.warn("Invalid vehicleInfo in localStorage");
        }
      }

      // Xây dựng vehicleInfo theo từng bước
      const vehicleInfo = {
        make: make || savedData.make || null,
        model: model || savedData.model || null,
        year: year || savedData.year || null,
        body: body || savedData.body || null,
        type: savedData.type || null
      };

      // Lưu vào localStorage theo từng bước
      // Bước 1: Chỉ có make → lưu make và update title
      if (make && !model && !year) {
        localStorage.setItem("vehicleInfo", JSON.stringify({ make: vehicleInfo.make }));
        this.updateCollectionHeroTitle({ make: vehicleInfo.make });
        return;
      }

      // Bước 2: Có make + model → lưu make và model, update title
      if (make && model && !year) {
        localStorage.setItem("vehicleInfo", JSON.stringify({ 
          make: vehicleInfo.make, 
          model: vehicleInfo.model 
        }));
        this.updateCollectionHeroTitle({ make: vehicleInfo.make, model: vehicleInfo.model });
        return;
      }

      // Bước 3: Có make + model + year → lưu đầy đủ và tìm type
      if (make && model && year) {
        // Flag để đảm bảo chỉ apply một lần
        let hasApplied = false;
        
        // Đợi YMM_DATA load để tìm type
        const getTypeWithRetry = (attempts = 0) => {
          if (typeof YMM_DATA === 'undefined' || !YMM_DATA) {
            if (attempts < 50) {
              setTimeout(() => getTypeWithRetry(attempts + 1), 200);
              return;
            } else {
              // Vẫn lưu vehicleInfo dù không có type
              localStorage.setItem("vehicleInfo", JSON.stringify(vehicleInfo));
              
              // Update collection hero title
              this.updateCollectionHeroTitle({ year, make, model, body });
              
              if (!hasApplied) {
                hasApplied = true;
                this.applySelections(vehicleInfo);
              }
              return;
            }
          }

          // Kiểm tra có body không
          const yearData = YMM_DATA[year];
          let hasBody = false;
          if (yearData) {
            const makeKey = Object.keys(yearData).find((k) => 
              this.normalizeKeyFromHandle(k).toLowerCase() === make.toLowerCase()
            );
            if (makeKey) {
              const modelKey = Object.keys(yearData[makeKey]).find((k) => {
                const normalizedKey = this.normalizeKeyFromHandle(k).toLowerCase();
                const normalizedModel = model.toLowerCase();
                return normalizedKey === normalizedModel || normalizedKey.includes(normalizedModel) || normalizedModel.includes(normalizedKey);
              });
              if (modelKey) {
                const modelData = yearData[makeKey][modelKey];
                hasBody = modelData && modelData.body && modelData.body.trim().length > 0;
              }
            }
          }

          // Tìm type
          const type = this.getVehicleType(year, make, model);
          if (type) {
            vehicleInfo.type = type;
            localStorage.setItem("vehicleInfo", JSON.stringify(vehicleInfo));
            
            // Update collection hero title
            this.updateCollectionHeroTitle({ year, make, model, body });
            
            // Luôn apply selections để fill filter (chỉ một lần)
            if (!hasApplied) {
              hasApplied = true;
              // Reset flag để cho phép apply
              this.hasAppliedSelections = null;
              this.isApplyingSelections = false;
              this.applySelections(vehicleInfo);
            }
          } else {
            // Vẫn lưu vehicleInfo dù không có type
            localStorage.setItem("vehicleInfo", JSON.stringify(vehicleInfo));
            
            // Update collection hero title
            this.updateCollectionHeroTitle({ year, make, model, body });
            
            // Luôn apply selections để fill filter (chỉ một lần)
            if (!hasApplied) {
              hasApplied = true;
              // Reset flag để cho phép apply
              this.hasAppliedSelections = null;
              this.isApplyingSelections = false;
              this.applySelections(vehicleInfo);
            }
          }
        };

        getTypeWithRetry();
      }
    }

    // Helper function để apply selections vào form
    applySelections(vehicleInfo) {
      const { year, make, model, body } = vehicleInfo;
      if (!(year && make && model)) return;

      // Tránh vòng lặp - nếu đang apply hoặc đã apply rồi thì return
      if (this.isApplyingSelections) {
        return;
      }

      // Kiểm tra xem đã apply với cùng dữ liệu chưa
      const currentKey = `${year}-${make}-${model}-${body || ''}`;
      if (this.hasAppliedSelections === currentKey) {
        return;
      }

      this.isApplyingSelections = true;
      this.hasAppliedSelections = currentKey;

      // Set flag để tránh trigger event khi set value programmatically
      this.isSettingValueProgrammatically = true;

      // Đợi YMM_DATA load nếu chưa có
      if (typeof YMM_DATA === 'undefined' || !YMM_DATA || Object.keys(YMM_DATA).length === 0) {
        // Retry sau 200ms
        setTimeout(() => {
          this.isApplyingSelections = false; // Reset flag để retry
          this.applySelections(vehicleInfo);
        }, 200);
        return;
      }

      // Helper function để tìm key match trong object (case-insensitive, ignore spaces)
      const findMatchingKey = (obj, targetKey) => {
        if (!obj || !targetKey) return null;
        const normalize = (str) => str?.toLowerCase().trim().replace(/\s+/g, ' ') || '';
        const targetNormalized = normalize(targetKey);
        
        // Thử exact match trước
        if (obj[targetKey]) return targetKey;
        
        // Tìm key match
        for (const key of Object.keys(obj)) {
          if (normalize(key) === targetNormalized) {
            return key;
          }
        }
        
        // Tìm partial match
        for (const key of Object.keys(obj)) {
          if (normalize(key).includes(targetNormalized) || targetNormalized.includes(normalize(key))) {
            return key;
          }
        }
        
        return null;
      };

      requestAnimationFrame(() => {
        // Luôn populate và set year
        if (this.yearSelect) {
          this.yearSelect.value = year;
          // Populate makes cho year này
          const makes = YMM_DATA[year];
          if (makes) {
            this.makeSelect.innerHTML = `<option value="">Select Make</option>`;
            Object.keys(makes).forEach((makeKey) => {
              this.makeSelect.innerHTML += `<option value="${makeKey}">${makeKey}</option>`;
            });
            this.makeSelect.disabled = false;
            
            // Tìm make match và set value
            const matchedMake = findMatchingKey(makes, make);
            if (matchedMake) {
              this.makeSelect.value = matchedMake;
            }
          }
        }

        requestAnimationFrame(() => {
          // Luôn populate và set make (sử dụng matched make nếu có)
          const makes = YMM_DATA[year];
          const matchedMake = makes ? findMatchingKey(makes, make) : null;
          const makeToUse = matchedMake || make;
          
          if (this.makeSelect && makeToUse) {
            this.makeSelect.value = makeToUse;
            // Populate models cho make này
            const models = YMM_DATA[year]?.[makeToUse];
            if (models) {
              this.modelSelect.innerHTML = `<option value="">Select Model</option>`;
              Object.keys(models).forEach((modelKey) => {
                this.modelSelect.innerHTML += `<option value="${modelKey}">${modelKey}</option>`;
              });
              
              // Tìm model match và set value
              const matchedModel = findMatchingKey(models, model);
              if (matchedModel) {
                this.modelSelect.value = matchedModel;
              }
            }
          }

          requestAnimationFrame(() => {
            // Luôn populate và set model (sử dụng matched model nếu có)
            const makes = YMM_DATA[year];
            const matchedMake = makes ? findMatchingKey(makes, make) : null;
            const makeToUse = matchedMake || make;
            const models = YMM_DATA[year]?.[makeToUse];
            const matchedModel = models ? findMatchingKey(models, model) : null;
            const modelToUse = matchedModel || model;
            
            if (this.modelSelect && modelToUse) {
              this.modelSelect.value = modelToUse;
              // Populate body nếu có
              const data = YMM_DATA[year]?.[makeToUse]?.[modelToUse];
              if (data?.body) {
                this.bodyParent.classList.remove("vt-hidden");
                const bodyOptions = data.body
                  .split(",")
                  .map((b) => b.trim())
                  .filter((b) => b.length > 0);
                this.bodySelect.innerHTML = `<option value="">Select Body</option>`;
                bodyOptions.forEach((b) => {
                  const option = document.createElement("option");
                  option.value = b;
                  option.textContent = b;
                  this.bodySelect.appendChild(option);
                });
              } else {
                this.bodyParent.classList.add("vt-hidden");
                this.bodySelect.innerHTML = "";
              }
            }

            // Set body value nếu có
            if (body && this.bodySelect) {
              // Đợi một chút để đảm bảo options đã được populate
              setTimeout(() => {
                // Tìm option match với body (có thể format khác nhau)
                const bodyLower = body.toLowerCase().trim();
                let matchedOption = null;
                
                // Thử match exact trước
                if (this.bodySelect.querySelector(`option[value="${body}"]`)) {
                  this.bodySelect.value = body;
                } else {
                  // Tìm option có text hoặc value match (case-insensitive, ignore spaces)
                  const options = this.bodySelect.querySelectorAll('option');
                  for (const option of options) {
                    const optionValue = (option.value || option.textContent).toLowerCase().trim();
                    const optionText = option.textContent.toLowerCase().trim();
                    // Normalize để so sánh (remove extra spaces, special chars)
                    const normalize = (str) => str.replace(/\s+/g, ' ').replace(/[()]/g, '').trim();
                    if (normalize(optionValue) === normalize(bodyLower) || 
                        normalize(optionText) === normalize(bodyLower) ||
                        optionValue.includes(bodyLower) || 
                        bodyLower.includes(optionValue)) {
                      matchedOption = option.value || option.textContent;
                      break;
                    }
                  }
                  
                  if (matchedOption) {
                    this.bodySelect.value = matchedOption;
                  }
                }
                
                this.toggleSubmit();
                this.isApplyingSelections = false;
                this.isSettingValueProgrammatically = false; // Reset flag
              }, 100); // Tăng delay để đảm bảo options đã populate
            } else {
              this.toggleSubmit();
              this.isApplyingSelections = false;
              this.isSettingValueProgrammatically = false; // Reset flag
            }
          });
        });
      });

      this.showCurrentSelectedCar({ year, make, model, body });
    }

    // Helper function để update collection hero title
    updateCollectionHeroTitle({ year, make, model, body, type }) {
      if (!this.collectionHeroTitle) return;

      const formatText = (text) => {
        if (!text) return "";
        return decodeURIComponent(text)
          .replace(/[-_]+/g, " ")
          .replace(/\s+/g, " ")
          // Thêm khoảng trắng giữa chữ và số (ví dụ: "Bed8" -> "Bed 8")
          .replace(/([a-zA-Z])(\d)/g, "$1 $2")
          // Thêm khoảng trắng giữa số và chữ (ví dụ: "8Ft" -> "8 Ft")
          .replace(/(\d)([a-zA-Z])/g, "$1 $2")
          .trim()
          .replace(/\b\w/g, (c) => c.toUpperCase());
      };

      let title = "";

      // Level 3: Có year + body → "{Year} {Make} {Model} {Body} Covers"
      if (year && make && model && body) {
        title = `${formatText(year)} ${formatText(make)} ${formatText(model)} ${formatText(body)} Covers`;
      }
      // Level 2: Có year, không có body → "{Year} {Make} {Model} Car Covers"
      else if (year && make && model) {
        title = `${formatText(year)} ${formatText(make)} ${formatText(model)} Car Covers`;
      }
      // Level 1: Chỉ có make + model → "{Make} {Model} Car Covers"
      else if (make && model) {
        title = `${formatText(make)} ${formatText(model)} Car Covers`;
      }
      // Type-only collection → "{Type} Cover"
      else if (type && !year && !make && !model) {
        title = `${formatText(type)} Cover`;
      }
      // Fallback: các trường hợp khác
      else {
        const parts = [];
        if (year) parts.push(formatText(year));
        if (make) parts.push(formatText(make));
        if (model) parts.push(formatText(model));
        if (body) parts.push(formatText(body));

        if (parts.length > 0) {
          title = parts.join(" ") + " Car Cover";
        }
      }

      if (title) {
        this.collectionHeroTitle.textContent = title;
        
        // Update page title
        const shopName = document.querySelector('meta[property="og:site_name"]')?.content || '';
        document.title = `${title} – ${shopName}`;
        const ogTitle = document.querySelector('meta[property="og:title"]');
        if (ogTitle) ogTitle.setAttribute('content', `${title} – ${shopName}`);
      } else {
        // Reset to default title if no data
        const shopName = document.querySelector('meta[property="og:site_name"]')?.content || '';
        document.title = `All Vehicles – ${shopName}`;
        const ogTitle = document.querySelector('meta[property="og:title"]');
        if (ogTitle) ogTitle.setAttribute('content', `All Vehicles – ${shopName}`);
      }
    }

    showCurrentSelectedCar({ year, make, model, body }) {
      if (!(year && make && model)) {
        this.currentSelectedCarWrapper?.forEach((e) => {
          e.classList.add("vt-hidden");
        });
        return;
      }

      const parts = [year, make, model];
      if (body) parts.push(`(${body})`);
      const formatText = (text) => {
        if (!text) return "";
        // Giải mã ký tự %20, chuyển - thành khoảng trắng, viết hoa chữ đầu
        return decodeURIComponent(text)
          .replace(/[-_]+/g, " ")
          .replace(/\s+/g, " ")
          // Thêm khoảng trắng giữa chữ và số (ví dụ: "Bed8" -> "Bed 8")
          .replace(/([a-zA-Z])(\d)/g, "$1 $2")
          // Thêm khoảng trắng giữa số và chữ (ví dụ: "8Ft" -> "8 Ft")
          .replace(/(\d)([a-zA-Z])/g, "$1 $2")
          .trim()
          .replace(/\b\w/g, (c) => c.toUpperCase());
      };

      const carString = parts.map(formatText).join(" ");

      if (this.currentSelectedCarWrapper.length > 0) {
        this.currentSelectedCarWrapper.forEach((e) => {
          e.classList.remove("vt-hidden");
        });
        this.currentSelectedCars.forEach((e) => {
          e.innerText = carString;
        });
        
        // Update collection hero title với format "Car Cover"
        this.updateCollectionHeroTitle({ year, make, model, body });

        this.element.classList.add("vt-hidden");

        const params = new URLSearchParams({ year, make, model });
        if (body) params.append("body", body);

        const collectionURL = `/collections/all?${params.toString()}`;
        const submitBtns = document.querySelectorAll(
          ".js-current-selected-car-submit"
        );
        if (submitBtns.length > 0)
          submitBtns.forEach((button) => {
            button.setAttribute("onclick", `location.href='${collectionURL}'`);
          });
      }
    }

    onYearChange(e) {
      // Tránh trigger khi đang set value programmatically
      if (this.isSettingValueProgrammatically) {
        return;
      }

      if (typeof YMM_DATA === 'undefined' || !YMM_DATA || Object.keys(YMM_DATA).length === 0) {
        console.warn("[onYearChange] YMM_DATA not available");
        return;
      }

      const year = e.target.value;
      this.makeSelect.innerHTML = `<option value="">Select Make</option>`;
      this.modelSelect.innerHTML = `<option value="">Select Model</option>`;
      this.bodySelect.innerHTML = "";
      this.bodyParent.classList.add("vt-hidden");

      const makes = YMM_DATA[year];
      if (makes) {
        this.makeSelect.disabled = false;
        Object.keys(makes).forEach((make) => {
          this.makeSelect.innerHTML += `<option value="${make}">${make}</option>`;
        });
      } else {
        this.makeSelect.disabled = true;
      }

      this.toggleSubmit();
    }

    onMakeChange(e) {
      // Tránh trigger khi đang set value programmatically
      if (this.isSettingValueProgrammatically) {
        return;
      }

      if (typeof YMM_DATA === 'undefined' || !YMM_DATA || Object.keys(YMM_DATA).length === 0) {
        console.warn("[onMakeChange] YMM_DATA not available");
        return;
      }

      const year = this.yearSelect.value;
      const make = e.target.value;
      this.modelSelect.innerHTML = `<option value="">Select Model</option>`;
      this.bodySelect.innerHTML = "";
      this.bodyParent.classList.add("vt-hidden");

      const models = YMM_DATA[year]?.[make];
      if (models) {
        Object.keys(models).forEach((model) => {
          this.modelSelect.innerHTML += `<option value="${model}">${model}</option>`;
        });
      }

      this.toggleSubmit();
    }

    onModelChange(e, triggeredByUser = false) {
      // Tránh trigger khi đang set value programmatically (trừ khi triggeredByUser = true)
      if (!triggeredByUser && this.isSettingValueProgrammatically) {
        return;
      }

      if (typeof YMM_DATA === 'undefined' || !YMM_DATA || Object.keys(YMM_DATA).length === 0) {
        console.warn("[onModelChange] YMM_DATA not available");
        return;
      }

      const year = this.yearSelect.value;
      const make = this.makeSelect.value;
      const model = e.target.value;

      const data = YMM_DATA[year]?.[make]?.[model];
      if (data?.body) {
        this.bodyParent.classList.remove("vt-hidden");

        const bodyOptions = data.body
          .split(",")
          .map((b) => b.trim())
          .filter((b) => b.length > 0);

        this.bodySelect.innerHTML = `<option value="">Select Body</option>`;

        bodyOptions.forEach((b) => {
          const option = document.createElement("option");
          option.value = b;
          option.textContent = b;
          this.bodySelect.appendChild(option);
        });

        if (bodyOptions.length === 1) {
          this.bodySelect.value = bodyOptions[0];
        }
      } else {
        this.bodyParent.classList.add("vt-hidden");
        this.bodySelect.innerHTML = "";
      }

      this.toggleSubmit(triggeredByUser);
    }

    toggleSubmit(triggeredByUser) {
      const year = this.yearSelect.value;
      const make = this.makeSelect.value;
      const model = this.modelSelect.value;
      const body = this.bodySelect.value;

      if (!(year && make && model)) {
        this.submitBtn.disabled = true;
        return;
      }

      const data = YMM_DATA?.[year]?.[make]?.[model];
      const requiresBody = !!data?.body;
      const isBodyValid = !requiresBody || (requiresBody && body);

      this.submitBtn.disabled = !isBodyValid;

      if (triggeredByUser) {
        this.submitBtn.click();
      }
    }

    onSubmit(e) {
      e.preventDefault();

      const year = this.yearSelect.value;
      const make = this.makeSelect.value;
      const model = this.modelSelect.value;
      const body = this.bodySelect.value;
      const baseUrl = this.submitBtn.dataset.url;
      const data = YMM_DATA?.[year]?.[make]?.[model];
      const type = data?.type || null;
      localStorage.setItem(
        "vehicleInfo",
        JSON.stringify({ year, make, model, body, type })
      );

      const params = new URLSearchParams({ year, make, model });
      if (body) params.append("body", body);

      const fullUrl = `${baseUrl}?${params.toString()}`;
      window.location.href = fullUrl;
    }

    handleProductMedia() {
      const template = document.querySelector(".js-variant-media");
      const productMediaWrapper = document.querySelector(
        ".js-product-media-wrap"
      );
      const loaderStage = document.querySelector(".js-product-loader");

      const showDefaultGallery = () => {
        productMediaWrapper.classList.remove("is-loading");
        loaderStage?.classList.add("is-loading");
      };

      if (!template) {
        return showDefaultGallery();
      }

      // Lấy từ URL params hoặc URL path, hoặc từ localStorage (cho type-only collections)
      const urlParams = new URLSearchParams(window.location.search);
      let type = urlParams.get("type");
      let year, make, model, body;

      // Nếu không có type trong URL params, thử lấy từ localStorage (cho type-only collections)
      if (!type) {
        try {
          const saved = localStorage.getItem("vehicleInfo");
          if (saved) {
            const parsed = JSON.parse(saved);
            // Chỉ lấy type nếu không có year/make/model (trường hợp type-only collection)
            if (parsed.type && !parsed.year && !parsed.make && !parsed.model) {
              type = parsed.type;
            }
          }
        } catch (e) {
          console.warn("Failed to parse vehicleInfo from localStorage");
        }
      }

      // Nếu vẫn không có type, thử lấy từ URL path và tìm type
      if (!type) {
        const pathParts = window.location.pathname.split("/").filter(Boolean);
        
        if (pathParts.length >= 3 && 
            pathParts[0] !== "collections" && 
            pathParts[0] !== "products" &&
            pathParts[0] !== "pages") {
          
          const thirdPart = pathParts[2];
          const isYear = !isNaN(thirdPart) && thirdPart.length === 4;
          
          if (isYear) {
            make = pathParts[0];
            model = pathParts[1];
            year = pathParts[2];
            body = pathParts[3] || null;
            
            // Format make/model từ slugs
            if (make) make = this.normalizeKeyFromHandle(make);
            if (model) model = this.normalizeKeyFromHandle(model);
            if (body) body = this.normalizeKeyFromHandle(body);
            
            // Tìm type từ YMM_DATA
            if (year && make && model && typeof YMM_DATA !== 'undefined' && YMM_DATA) {
              type = this.getVehicleType(year, make, model);
            }
          }
        }
        
        // Nếu vẫn không có type, thử lấy year/make/model từ URL params và tìm type
        if (!type) {
          year = urlParams.get("year");
          make = urlParams.get("make");
          model = urlParams.get("model");
          body = urlParams.get("body");
          
          if (year && make && model && typeof YMM_DATA !== 'undefined' && YMM_DATA) {
            // Format make/model
            if (make) make = this.normalizeKeyFromHandle(make);
            if (model) model = this.normalizeKeyFromHandle(model);
            if (body) body = this.normalizeKeyFromHandle(body);
            
            type = this.getVehicleType(year, make, model);
          }
        }
      }

      if (!type) {
        return showDefaultGallery();
      }

      const groupSelector = `.js-${type.toLowerCase()}-group`;
      const imageGroup = template.content.querySelector(groupSelector);
      const galleryList = document.querySelector(".js-slider-list");

      if (!imageGroup) {
        return showDefaultGallery();
      }

      const newSlides = imageGroup.querySelectorAll(".js-slider-item");

      if (newSlides.length === 0) {
        return showDefaultGallery();
      }

      galleryList.innerHTML = "";
      newSlides.forEach((slide) => {
        galleryList.appendChild(slide.cloneNode(true));
      });
      const sliderComponent = document.querySelector("slider-component");
      sliderComponent?.resetPages();
      showDefaultGallery();
    }

    hideBlockedRelatedProducts() {
      const relatedProductsSection = document.querySelector("product-recommendations");
      if (!relatedProductsSection) return;

      // Lấy type từ URL params, URL path, hoặc localStorage (cho type-only collections)
      const urlParams = new URLSearchParams(window.location.search);
      let type = urlParams.get("type");
      let year, make, model, body;

      // Nếu không có type trong URL params, thử lấy từ localStorage (cho type-only collections)
      if (!type) {
        try {
          const saved = localStorage.getItem("vehicleInfo");
          if (saved) {
            const parsed = JSON.parse(saved);
            // Lấy type từ localStorage nếu có (cho trường hợp type-only collection)
            if (parsed.type) {
              type = parsed.type;
            }
          }
        } catch (e) {
          console.warn("Failed to parse vehicleInfo from localStorage");
        }
      }

      // Nếu vẫn không có type, thử lấy từ URL path và tìm type
      if (!type) {
        const pathParts = window.location.pathname.split("/").filter(Boolean);
        
        if (pathParts.length >= 3 && 
            pathParts[0] !== "collections" && 
            pathParts[0] !== "products" &&
            pathParts[0] !== "pages") {
          
          const thirdPart = pathParts[2];
          const isYear = !isNaN(thirdPart) && thirdPart.length === 4;
          
          if (isYear) {
            make = pathParts[0];
            model = pathParts[1];
            year = pathParts[2];
            body = pathParts[3] || null;
            
            // Format make/model từ slugs
            if (make) make = this.normalizeKeyFromHandle(make);
            if (model) model = this.normalizeKeyFromHandle(model);
            if (body) body = this.normalizeKeyFromHandle(body);
            
            // Tìm type từ YMM_DATA
            if (year && make && model && typeof YMM_DATA !== 'undefined' && YMM_DATA) {
              type = this.getVehicleType(year, make, model);
            }
          }
        }
        
        // Nếu vẫn không có type, thử lấy year/make/model từ URL params và tìm type
        if (!type) {
          year = urlParams.get("year");
          make = urlParams.get("make");
          model = urlParams.get("model");
          body = urlParams.get("body");
          
          if (year && make && model && typeof YMM_DATA !== 'undefined' && YMM_DATA) {
            // Format make/model
            if (make) make = this.normalizeKeyFromHandle(make);
            if (model) model = this.normalizeKeyFromHandle(model);
            if (body) body = this.normalizeKeyFromHandle(body);
            
            type = this.getVehicleType(year, make, model);
          }
        }
      }

      if (!type) return;

      // Normalize type (remove "Cover" if present)
      if (type.includes("Cover")) {
        const splitType = type.split(" ");
        type = splitType[0];
      }

      const typeLower = type.toLowerCase();
      const cardItems = relatedProductsSection.querySelectorAll("li.grid__item");

      cardItems.forEach((cardItem) => {
        // Try multiple selectors to find title
        const titleEl = 
          cardItem.querySelector(".js-collections-heading") ||
          cardItem.querySelector(".card__heading a") ||
          cardItem.querySelector(".card__heading");
        
        if (!titleEl) return;

        const title = titleEl.textContent?.toLowerCase() || "";

        // VAN: không có Indoor và Ultimum Lite
        const isVanAndBlocked =
          typeLower.includes("van") &&
          (title.includes("indoor") || title.includes("ultimum lite"));

        // Truck: không có SoftTec Indoor
        const isTruckAndBlocked =
          typeLower.includes("truck") &&
          title.includes("softtec") &&
          title.includes("indoor");

        if (isVanAndBlocked || isTruckAndBlocked) {
          cardItem.style.display = "none";
        }
      });
    }

    updateRelatedProductLinks() {
      const relatedProductsSection = document.querySelector("product-recommendations");
      if (!relatedProductsSection) return;

      // Kiểm tra xem có products đã render chưa
      const headingElements = relatedProductsSection.querySelectorAll('.js-collections-heading');
      if (headingElements.length === 0) {
        return false; // Chưa có products, return false để retry
      }

      // Lấy vehicle info từ URL params, URL path, hoặc localStorage (giống changeCardName)
      const urlParams = new URLSearchParams(window.location.search);
      let year = urlParams.get("year");
      let make = urlParams.get("make");
      let model = urlParams.get("model");
      let body = urlParams.get("body");

      const currentPath = window.location.pathname;
      const pathParts = currentPath.split("/").filter(Boolean);

      // Parse từ URL path (giống changeCardName)
      if (pathParts.length >= 3) {
        year = year || decodeURIComponent(pathParts[pathParts.length - 2]);
        model = model || decodeURIComponent(pathParts[pathParts.length - 3]);
        make = make || decodeURIComponent(pathParts[pathParts.length - 4]);

        const maybeBody = pathParts[pathParts.length - 1];
        if (maybeBody && isNaN(maybeBody)) {
          body = body || decodeURIComponent(maybeBody);
        } else {
          year = year || decodeURIComponent(pathParts[pathParts.length - 1]);
          model = model || decodeURIComponent(pathParts[pathParts.length - 2]);
          make = make || decodeURIComponent(pathParts[pathParts.length - 3]);
        }
      }

      // Nếu không có trong URL, thử lấy từ localStorage
      if (!(year && make && model)) {
        try {
          const saved = localStorage.getItem("vehicleInfo");
          if (saved) {
            const parsed = JSON.parse(saved);
            year = year || parsed.year;
            make = make || parsed.make;
            model = model || parsed.model;
            body = body || parsed.body;
          }
        } catch (e) {
          console.warn("[updateRelatedProductLinks] Failed to parse vehicleInfo from localStorage");
        }
      }

      // Nếu không có đủ thông tin, không update
      if (!(year && make && model)) {
        return true; // Không có vehicle info, nhưng đã có products nên return true
      }

      // Format text helper (giống changeCardName)
      const formatText = (str) =>
        str
          .replace(/-/g, " ")
          .replace(/\s+/g, " ")
          // Thêm khoảng trắng giữa chữ và số (ví dụ: "Bed8" -> "Bed 8")
          .replace(/([a-zA-Z])(\d)/g, "$1 $2")
          // Thêm khoảng trắng giữa số và chữ (ví dụ: "8Ft" -> "8 Ft")
          .replace(/(\d)([a-zA-Z])/g, "$1 $2")
          .trim()
          .replace(/\b\w/g, (c) => c.toUpperCase());

      // Update tất cả các js-collections-heading trong product-recommendations
      headingElements.forEach((titleEl) => {
        // Lưu original text nếu chưa có
        if (!titleEl.dataset.originalText) {
          titleEl.dataset.originalText = titleEl.textContent;
        }

        // Update text với suffix (giống changeCardName)
        const suffixParts = [year, make, model];
        if (body) suffixParts.push(body);
        // Format từng phần trước khi join để đảm bảo format đúng
        const formattedSuffixParts = suffixParts.map(part => formatText(part));
        const suffix = ` for ${formattedSuffixParts.join(" ")}`;
        titleEl.textContent = formatText(
          `${titleEl.dataset.originalText}${suffix}`
        );

        // Update link (giống changeCardName)
        let linkEl = null;
        if (titleEl.tagName === "A") {
          linkEl = titleEl;
        } else {
          linkEl = titleEl.querySelector('a');
        }

        if (linkEl) {
          const href = linkEl.getAttribute("href");
          if (href && href.includes("/products/")) {
            try {
              const url = new URL(href, window.location.origin);
              if (year) url.searchParams.set("year", year);
              if (make) url.searchParams.set("make", this.slugify(make));
              if (model) url.searchParams.set("model", this.slugify(model));
              if (body) url.searchParams.set("body", this.slugify(body));
              linkEl.setAttribute("href", url.pathname + url.search);
            } catch (err) {
              console.warn("[updateRelatedProductLinks] Failed to update link", err);
            }
          }
        }
      });

      return true; // Đã update xong
    }

    handleRelatedProductsMedia() {
      const relatedProductsSection = document.querySelector("product-recommendations");
      if (!relatedProductsSection) return;

      const applyImages = () => {
        const cardMedias = relatedProductsSection.querySelectorAll(".js-card-media");
        if (cardMedias.length === 0) {
          return false;
        }

        // Check if YMM_DATA is available - wait for it to load
        if (typeof YMM_DATA === 'undefined' || !YMM_DATA) {
          return false; // Return false to trigger retry
        }

        // Lấy vehicle info từ URL params TRƯỚC (ưu tiên cao nhất)
        const urlParams = new URLSearchParams(window.location.search);
        let year = urlParams.get("year");
        let make = urlParams.get("make");
        let model = urlParams.get("model");
        let body = urlParams.get("body");
        let type = urlParams.get("type");

        // Nếu có đủ year, make, model từ URL params, tìm type
        if (year && make && model && !type) {
          // Format make/model từ URL params (có thể là slug)
          const formattedMake = this.normalizeKeyFromHandle(make);
          const formattedModel = this.normalizeKeyFromHandle(model);
          type = this.getVehicleType(year, formattedMake, formattedModel);
          console.log(`[applyImages] Found type from URL params: ${type} for ${year} ${formattedMake} ${formattedModel}`);
        }

        // Nếu không có từ URL params, thử lấy từ localStorage
        if (!type) {
          try {
            const saved = localStorage.getItem("vehicleInfo");
            if (saved) {
              const parsed = JSON.parse(saved);
              // Lấy type từ localStorage nếu có
              if (parsed.type) {
                type = parsed.type;
              }
              // Lấy year/make/model từ localStorage nếu chưa có
              year = year || parsed.year;
              make = make || parsed.make;
              model = model || parsed.model;
              body = body || parsed.body;
              
              // Nếu có đủ year/make/model từ localStorage nhưng chưa có type, tìm type
              if (!type && year && make && model) {
                const formattedMake = this.normalizeKeyFromHandle(make);
                const formattedModel = this.normalizeKeyFromHandle(model);
                type = this.getVehicleType(year, formattedMake, formattedModel);
                console.log(`[applyImages] Found type from localStorage vehicle info: ${type}`);
              }
            }
          } catch (e) {
            console.warn("Failed to parse vehicleInfo from localStorage");
          }
        }

        // Try to get from URL path (e.g., /bmw/x6/2026 or /bmw/x6/2026/body-name)
        if (!type) {
          const pathParts = window.location.pathname.split("/").filter(Boolean);
          
          // Check if path looks like vehicle path (not /collections/... or /products/...)
          // Pattern: /make/model/year or /make/model/year/body
          if (pathParts.length >= 3 && 
              pathParts[0] !== "collections" && 
              pathParts[0] !== "products" &&
              pathParts[0] !== "pages" &&
              pathParts[0] !== "cart" &&
              pathParts[0] !== "account") {
            
            // Try to parse: [make, model, year] or [make, model, year, body]
            // Check if third part is a year (numeric)
            const thirdPart = pathParts[2];
            const isYear = !isNaN(thirdPart) && thirdPart.length === 4;
            
            if (isYear) {
              make = make || pathParts[0];
              model = model || pathParts[1];
              year = year || pathParts[2];
              body = body || pathParts[3] || null;
              
              // Format make/model từ slugs
              const formattedMake = this.normalizeKeyFromHandle(make);
              const formattedModel = this.normalizeKeyFromHandle(model);
              
              // Get type from YMM_DATA
              type = this.getVehicleType(year, formattedMake, formattedModel);
              console.log(`[applyImages] Found type from URL path: ${type}`);
            }
          }
        }

        if (!type) {
          console.warn(`[applyImages] Could not find type for year=${year}, make=${make}, model=${model}`);
          return false;
        }
        
        // Normalize type (remove "Cover" if present, capitalize first letter)
        if (type.includes("Cover")) {
          const splitType = type.split(" ");
          type = splitType[0];
        }
        
        // Đảm bảo type được capitalize đúng (Car, Truck, Van, SUV)
        type = type.charAt(0).toUpperCase() + type.slice(1).toLowerCase();

        const vehicleSearchParams = new URLSearchParams();
        if (year) vehicleSearchParams.set("year", year);
        if (make) vehicleSearchParams.set("make", make);
        if (model) vehicleSearchParams.set("model", model);
        if (body) vehicleSearchParams.set("body", body);
        const vehicleQueryString = vehicleSearchParams.toString();

        const typeLower = type.toLowerCase();

        // Apply images to all related product cards and hide blocked items
        cardMedias.forEach((cardMedia) => {
          const cardItem = cardMedia.closest("li.grid__item");
          if (!cardItem) return;

          // Lấy ảnh từ template.js-recommendation-images của recommendation này
          const recommendationTemplate = cardItem.querySelector("template.js-recommendation-images");
          let imageData = [];

          if (recommendationTemplate) {
            // Clone template content để đọc ảnh
            const tempContainer = document.createElement("div");
            tempContainer.appendChild(recommendationTemplate.content.cloneNode(true));
            
            // Tìm div.js-type-images có data-type = typeLower
            const typeImagesDiv = tempContainer.querySelector(`.js-type-images[data-type="${typeLower}"]`);
            
            if (typeImagesDiv) {
              const imgs = typeImagesDiv.querySelectorAll("img");
              imgs.forEach((img) => {
                const src = img.getAttribute("src");
                const srcset = img.getAttribute("srcset") || "";
                const alt = img.getAttribute("alt") || "";
                if (src) {
                  imageData.push({ src, srcset, alt });
                }
              });
            }
          }

          // Nếu không có ảnh từ template recommendation, fallback về template variant-media
          if (imageData.length === 0) {
            const variantMediaTemplate = document.querySelector(".js-variant-media");
            if (variantMediaTemplate) {
              const tempContainer = document.createElement("div");
              tempContainer.appendChild(variantMediaTemplate.content.cloneNode(true));
              
              const imageGroup = tempContainer.querySelector(`.js-${typeLower}-group`);
              if (imageGroup) {
                const sliderItems = imageGroup.querySelectorAll(".js-slider-item");
                const images = [];
                
                if (sliderItems.length > 0) {
                  sliderItems.forEach((item) => {
                    const img = item.querySelector("img");
                    if (img) images.push(img);
                  });
                } else {
                  const directImages = imageGroup.querySelectorAll("img");
                  directImages.forEach((img) => images.push(img));
                }

                for (let i = 0; i < Math.min(2, images.length); i++) {
                  const img = images[i];
                  let src = img.getAttribute("src") || img.src || img.currentSrc;
                  
                  if (!src || src.startsWith("data:") || src === window.location.href) {
                    const srcset = img.getAttribute("srcset") || img.srcset || "";
                    if (srcset) {
                      const firstSrcset = srcset.split(",")[0]?.trim().split(/\s+/)[0];
                      if (firstSrcset && (firstSrcset.startsWith("http") || firstSrcset.startsWith("/"))) {
                        src = firstSrcset;
                      }
                    }
                    if (!src || src.startsWith("data:") || src === window.location.href) {
                      src = img.getAttribute("data-src") || img.getAttribute("data-lazy-src") || "";
                    }
                  }
                  
                  if (src && src.startsWith("/") && !src.startsWith("//")) {
                    src = window.location.origin + src;
                  }
                  
                  if (src && !src.startsWith("data:") && src !== window.location.href && 
                      (src.startsWith("http") || src.startsWith("//"))) {
                    const srcset = img.getAttribute("srcset") || img.srcset || "";
                    const alt = img.getAttribute("alt") || img.alt || "";
                    imageData.push({ src, srcset, alt });
                  }
                }
              }
            }
          }

          // Skip nếu không có ảnh
          if (imageData.length === 0) return;

          // Try multiple selectors to find title
          const titleEl = 
            cardItem.querySelector(".js-collections-heading") ||
            cardItem.querySelector(".card__heading a") ||
            cardItem.querySelector(".card__heading");
          
          if (titleEl) {
            const title = titleEl.textContent?.toLowerCase() || "";
            
            // VAN: không có Indoor và Ultimum Lite
            const isVanAndBlocked =
              typeLower.includes("van") &&
              (title.includes("indoor") || title.includes("ultimum lite"));

            // Truck: không có SoftTec Indoor
            const isTruckAndBlocked =
              typeLower.includes("truck") &&
              title.includes("softtec") &&
              title.includes("indoor");

            if (isVanAndBlocked || isTruckAndBlocked) {
              cardItem.style.display = "none";
              return; // Skip applying image to hidden items
            }
          }

          // Update all product links with vehicle info so we can navigate with selected filters
          if (vehicleQueryString) {
            // Update links with class js-collections-heading
            const headingLinks = cardItem.querySelectorAll('a.js-collections-heading, .js-collections-heading a');
            headingLinks.forEach((linkEl) => {
              try {
                const linkUrl = new URL(linkEl.getAttribute("href"), window.location.origin);
                const params = new URLSearchParams(linkUrl.search);
                vehicleSearchParams.forEach((value, key) => {
                  params.set(key, value);
                });
                const newQuery = params.toString();
                linkUrl.search = newQuery ? `?${newQuery}` : "";
                const updatedHref = linkUrl.pathname + linkUrl.search + linkUrl.hash;
                linkEl.setAttribute("href", updatedHref);
              } catch (err) {
                console.warn("[handleRelatedProductsMedia] Failed to update js-collections-heading link with vehicle info", err);
              }
            });

            // Update all product links
            const productLinks = cardItem.querySelectorAll('a[href*="/products/"]');
            productLinks.forEach((linkEl) => {
              try {
                const linkUrl = new URL(linkEl.getAttribute("href"), window.location.origin);
                const params = new URLSearchParams(linkUrl.search);
                vehicleSearchParams.forEach((value, key) => {
                  params.set(key, value);
                });
                const newQuery = params.toString();
                linkUrl.search = newQuery ? `?${newQuery}` : "";
                const updatedHref = linkUrl.pathname + linkUrl.search + linkUrl.hash;
                linkEl.setAttribute("href", updatedHref);
              } catch (err) {
                console.warn("[handleRelatedProductsMedia] Failed to update product link with vehicle info", err);
              }
            });
          }

          // Get all images in card__media (could be featured image and secondary image)
          const cardImages = cardMedia.querySelectorAll("img");
          
          if (cardImages.length > 0 && imageData.length > 0) {
            // Apply images: first image to first img, second image to second img (if exists)
            cardImages.forEach((img, index) => {
              const imageToUse = imageData[index] || imageData[0]; // Use first image as fallback
              
              if (imageToUse?.src) {
                // Force update using setAttribute to ensure browser recognizes the change
                img.setAttribute("src", imageToUse.src);
                
                // Update srcset
                if (imageToUse.srcset) {
                  img.setAttribute("srcset", imageToUse.srcset);
                } else {
                  img.removeAttribute("srcset");
                }
                
                // Update alt
                if (imageToUse.alt) {
                  img.setAttribute("alt", imageToUse.alt);
                }
                
                // Force browser to reload image
                img.loading = "eager";
                
                // Trigger image reload by setting src again
                const currentSrc = img.src;
                img.src = "";
                img.src = imageToUse.src;
              }
            });
          }
        });

        return true;
      };

      // Function to update links and names
      const updateLinksAndNames = () => {
        const result = this.updateRelatedProductLinks();
        return result; // Return true if successful, false if needs retry
      };

      // Check if products are already loaded
      if (relatedProductsSection.classList.contains('product-recommendations--loaded')) {
        setTimeout(() => {
          this.hideBlockedRelatedProducts();
          applyImages();
          updateLinksAndNames();
        }, 100);
      }

      // Listen for custom event when products are loaded
      const handleProductsLoaded = () => {
        setTimeout(() => {
          this.hideBlockedRelatedProducts();
          applyImages();
          updateLinksAndNames();
        }, 100); // Small delay to ensure DOM is ready
      };

      relatedProductsSection.addEventListener('product-recommendations-loaded', handleProductsLoaded);

      // Try immediately
      if (applyImages()) {
        updateLinksAndNames();
        return;
      }

      let attempts = 0;
      const maxAttempts = 100; // Try for up to 20 seconds (100 * 200ms) to wait for YMM_DATA
      let observer = null;

      // Polling function to check for card medias, YMM_DATA, and products
      const pollForMedias = () => {
        attempts++;
        
        // Check if YMM_DATA is now available
        if (typeof YMM_DATA === 'undefined' || !YMM_DATA) {
          if (attempts < maxAttempts) {
            setTimeout(pollForMedias, 200); // Check every 200ms
            return;
          } else {
            if (observer) observer.disconnect();
            return;
          }
        }
        
        // Try to apply images
        const imagesApplied = applyImages();
        
        // Try to update links and names (will return false if products not ready)
        const linksUpdated = updateLinksAndNames();
        
        // If both are done, stop polling
        if (imagesApplied && linksUpdated) {
          if (observer) observer.disconnect();
          return;
        }

        if (attempts < maxAttempts) {
          setTimeout(pollForMedias, 200); // Check every 200ms
        } else {
          if (observer) observer.disconnect();
        }
      };

      // Use MutationObserver to detect when related products are loaded
      observer = new MutationObserver((mutations) => {
        // Check if class 'product-recommendations--loaded' was added
        const hasLoadedClass = relatedProductsSection.classList.contains('product-recommendations--loaded');
        
        if (hasLoadedClass) {
          setTimeout(() => {
            this.hideBlockedRelatedProducts();
            applyImages();
            updateLinksAndNames();
          }, 100);
        } else {
          this.hideBlockedRelatedProducts();
          if (applyImages()) {
            updateLinksAndNames();
            observer.disconnect();
          }
        }
      });

      // Start observing
      observer.observe(relatedProductsSection, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'style']
      });

      // Start polling
      pollForMedias();

      // Also try after delays in case products load asynchronously
      setTimeout(() => {
        this.hideBlockedRelatedProducts();
        applyImages();
        updateLinksAndNames();
      }, 1000);

      setTimeout(() => {
        this.hideBlockedRelatedProducts();
        applyImages();
        updateLinksAndNames();
        if (observer) observer.disconnect();
      }, 3000);
    }

    handleProductPage() {
      this.handleProductMedia();
      this.handleRelatedProductsMedia();
      this.hideBlockedRelatedProducts();
      const wrapper = document.querySelector(".js-brand-system");
      const brandInfor = document.querySelector(".js-brand-infors");
      const brandVehicle = document.querySelector(".js-brand-choose-vehicle");
      const carInfoBox = wrapper?.querySelector(".js-car-selected");
      const notSelectedBox = wrapper?.querySelector(".js-not-selected");
      const carModelEl = wrapper?.querySelector(".js-car-model");
      const carYearEl = wrapper?.querySelector(".js-car-year");
      const form = document.querySelector(".js-product-form");
      const buttons = document.querySelectorAll(".js-product-button");

      const urlParams = new URLSearchParams(window.location.search);
      let year = urlParams.get("year");
      let make = urlParams.get("make");
      let model = urlParams.get("model");
      let body = urlParams.get("body");
      let type;

      if (JSON.parse(localStorage.getItem("vehicleInfo"))) {
        type = JSON.parse(localStorage.getItem("vehicleInfo")).type
        if (type) {
          let infoTabs = document.querySelectorAll(".js-info-tabs");
  
          infoTabs.forEach((e) => {
            e.setAttribute(`data-vehicle`, type);
          });
        }
      }

      // Nếu không có trong URL params, thử lấy từ URL path (ví dụ: /bmw/x6/2026)
      if (!(year && make && model)) {
        const pathParts = window.location.pathname.split("/").filter(Boolean);
        
        // Check if path looks like vehicle path (not /collections/... or /products/...)
        if (pathParts.length >= 3 && 
            pathParts[0] !== "collections" && 
            pathParts[0] !== "products" &&
            pathParts[0] !== "pages") {
          
          const thirdPart = pathParts[2];
          const isYear = !isNaN(thirdPart) && thirdPart.length === 4;
          
          if (isYear) {
            make = make || pathParts[0];
            model = model || pathParts[1];
            year = year || pathParts[2];
            body = body || pathParts[3] || null;
            
            // Format make/model từ slugs
            if (make) make = this.normalizeKeyFromHandle(make);
            if (model) model = this.normalizeKeyFromHandle(model);
            if (body) body = this.normalizeKeyFromHandle(body);
          }
        }
      }

      // KHÔNG lấy từ localStorage - chỉ lấy từ URL
      // if (!(year && make && model)) {
      //   localStorage.removeItem("vehicleInfo");
      // }

      const hasVehicle = year && make && model;
      
      if (!hasVehicle) {
        brandInfor.classList.add("vt-hidden");
        brandVehicle.classList.remove("vt-hidden");
        carInfoBox?.classList.add("vt-hidden");
        notSelectedBox?.classList.remove("vt-hidden");
        buttons.forEach((button) => button.classList.add("vt-hidden"));
        return;
      }
      
      // Đợi YMM_DATA load để tìm type từ year/make/model
      const carTypeEl = wrapper?.querySelector(".js-car-type");
      
      const getTypeWithRetry = (attempts = 0) => {
        if (typeof YMM_DATA === 'undefined' || !YMM_DATA) {
          if (attempts < 50) {
            setTimeout(() => getTypeWithRetry(attempts + 1), 200);
            return;
          } else {
            console.warn("[handleProductPage] YMM_DATA not available after retries");
            return;
          }
        }

        type = this.getVehicleType(year, make, model);

        if (type) {
          if (type.toLowerCase().includes("covers")) {
            const splitType = type.split(" ");
            type = splitType[0];
          }
          const vehicleInfo = { year, make, model, body, type };
          localStorage.setItem("vehicleInfo", JSON.stringify(vehicleInfo));
          
          // Hiển thị type nếu có element
          if (carTypeEl) {
            carTypeEl.textContent = type;
            carTypeEl.classList.remove("vt-hidden");
          }
          
          this.handleProductPrices(type);
        } else {
          console.warn(`[handleProductPage] Could not find type for ${year} ${make} ${model}`);
        }
      };

      getTypeWithRetry();

      wrapper?.classList.remove("vt-hidden");
      carInfoBox?.classList.remove("vt-hidden");
      notSelectedBox?.classList.add("vt-hidden");

      function cleanText(str) {
        return decodeURIComponent(str || "")
          .replace(/-/g, " ")
          .replace(/\s+/g, " ")
          .trim();
      }
      const formatText = (str) =>
        str
          .replace(/-/g, " ")
          .replace(/\s+/g, " ")
          .trim()
          .replace(/\b\w/g, (c) => c.toUpperCase());

      const parts = [make, model].filter(Boolean).map(cleanText);
      if (body) parts.push(`(${cleanText(body)})`);

      if (carModelEl) carModelEl.textContent = formatText(parts.join(" "));
      if (carYearEl) carYearEl.textContent = formatText(`${year}`);

      if (form && hasVehicle) {
        const existingInput = form.querySelector(
          'input[name="properties[Vehicle Info]"]'
        );
        if (!existingInput) {
          const input = document.createElement("input");
          input.type = "hidden";
          input.name = "properties[Vehicle Info]";
          input.value = `${year} ${make} ${model}${body ? ` (${body})` : ""}`;
          form.appendChild(input);
        }
      }

      const vehicleInfo = { year, make, model };
      if (body) vehicleInfo.body = body;
      if (type) {
        if (type.toLowerCase().includes("covers")) {
          const splitType = type.split(" ");
          type = splitType[0];
        }
        vehicleInfo.type = type;

        let infoTabs = document.querySelectorAll(".js-info-tabs");

        infoTabs.forEach((e) => {
          e.setAttribute(`data-vehicle`, type);
        });
      }
      localStorage.setItem("vehicleInfo", JSON.stringify(vehicleInfo));
    }

    handleCollections() {
      this.changeCardName();
      this.changeCardMedia();
      this.bindProductClickToClearStorage();
    }

    handleProductPrices(type) {
      const priceVariants = document.querySelectorAll(".js-product-variant");
      priceVariants.forEach((priceVariant) => {
        const variantType = priceVariant.dataset.type;
        if (type.includes(variantType)) {
          priceVariant.click();
        }
      });
    }

    changeCardName() {
      const titles = document.querySelectorAll(".js-collections-heading");
      const saved = localStorage.getItem("vehicleInfo");
      let year, make, model, body, type;

      const currentPath = window.location.pathname;
      const pathParts = currentPath.split("/").filter(Boolean);

      const match = currentPath.match(/^\/collections\/([^/]+)-covers$/i);

      if (match && match[1]) {
        type = match[1];
        const typeLower = type.toLowerCase();

        titles.forEach((titleEl) => {
          if (!titleEl.dataset.originalText) {
            titleEl.dataset.originalText = titleEl.textContent;
          }

          const formatText = (str) =>
            str
              .replace(/-/g, " ")
              .replace(/\s+/g, " ")
              // Thêm khoảng trắng giữa chữ và số (ví dụ: "Bed8" -> "Bed 8")
              .replace(/([a-zA-Z])(\d)/g, "$1 $2")
              // Thêm khoảng trắng giữa số và chữ (ví dụ: "8Ft" -> "8 Ft")
              .replace(/(\d)([a-zA-Z])/g, "$1 $2")
              .trim()
              .replace(/\b\w/g, (c) => c.toUpperCase());

          const suffix = ` for ${formatText(type)}`;
          titleEl.textContent = formatText(
            `${titleEl.dataset.originalText}${suffix}`
          );

          // --- Hide blocked items for type-only collection ---
          const gridItem = titleEl.closest("li");
          if (gridItem) {
            const name = titleEl.textContent.toLowerCase();
            
            // VAN: không có Indoor và Ultimum Lite
            const isVanAndBlocked =
              typeLower.includes("van") &&
              (name.includes("indoor") || name.includes("ultimum lite"));
            
            // Truck: không có SoftTec Indoor
            const isTruckAndBlocked =
              typeLower.includes("truck") && 
              name.includes("softtec") && 
              name.includes("indoor");

            if (isVanAndBlocked || isTruckAndBlocked) {
              gridItem.style.display = "none";
            } else {
              // Ensure item is visible if not blocked
              gridItem.style.display = "";
            }
          }

          // --- Update link params (không clear localStorage ở đây, để bindProductClickToClearStorage xử lý) ---
          // Logic clear/save localStorage được xử lý trong bindProductClickToClearStorage()
        });

        // Bind click events for all product links to handle localStorage
        this.bindProductClickToClearStorage();

        return;
      }

      if (pathParts.length >= 3) {
        year = decodeURIComponent(pathParts[pathParts.length - 2]);
        model = decodeURIComponent(pathParts[pathParts.length - 3]);
        make = decodeURIComponent(pathParts[pathParts.length - 4]);

        const maybeBody = pathParts[pathParts.length - 1];
        if (maybeBody && isNaN(maybeBody)) {
          body = decodeURIComponent(maybeBody);
        } else {
          year = decodeURIComponent(pathParts[pathParts.length - 1]);
          model = decodeURIComponent(pathParts[pathParts.length - 2]);
          make = decodeURIComponent(pathParts[pathParts.length - 3]);
        }
      }

      if (!(year && make && model) && saved) {
        try {
          const parsed = JSON.parse(saved);
          year = parsed.year;
          make = parsed.make;
          model = parsed.model;
          body = parsed.body;
          type = parsed.type;
        } catch (err) {
          console.warn("Invalid vehicleInfo in localStorage");
        }
      }

      if (!(year && make && model)) return;

      // --- 3️⃣ Update titles ---
      titles.forEach((titleEl) => {
        if (!titleEl.dataset.originalText) {
          titleEl.dataset.originalText = titleEl.textContent;
        }

        const formatText = (str) =>
          str
            .replace(/-/g, " ")
            .replace(/\s+/g, " ")
            // Thêm khoảng trắng giữa chữ và số (ví dụ: "Bed8" -> "Bed 8")
            .replace(/([a-zA-Z])(\d)/g, "$1 $2")
            // Thêm khoảng trắng giữa số và chữ (ví dụ: "8Ft" -> "8 Ft")
            .replace(/(\d)([a-zA-Z])/g, "$1 $2")
            .trim()
            .replace(/\b\w/g, (c) => c.toUpperCase());

        const suffixParts = [year, make, model];
        if (body) suffixParts.push(body);
        // Format từng phần trước khi join để đảm bảo format đúng
        const formattedSuffixParts = suffixParts.map(part => formatText(part));
        const suffix = ` for ${formattedSuffixParts.join(" ")}`;
        titleEl.textContent = formatText(
          `${titleEl.dataset.originalText}${suffix}`
        );

        // --- Update link params ---
        if (titleEl.tagName === "A") {
          const href = titleEl.getAttribute("href");

          if (href) {
            const url = new URL(href, window.location.origin);
            if (year) url.searchParams.set("year", year);
            if (make) url.searchParams.set("make", make);
            if (model) url.searchParams.set("model", model);
            if (body) url.searchParams.set("body", body);
            titleEl.setAttribute("href", url.pathname + url.search);
          }
        }

        // --- Hide blocked items ---
        const gridItem = titleEl.closest("li");
        const currentPath = window.location.pathname;
        let type = null;

        const match = currentPath.match(/\/collections\/([^/]+)-covers/i);
        if (match && match[1]) {
          type = match[1];
        } else if (saved) {
          try {
            const parsed = JSON.parse(saved);
            type = parsed.type;
          } catch (err) {
            console.warn("Invalid vehicleInfo in localStorage");
          }
        }
        if (gridItem) {
          const name = titleEl.textContent.toLowerCase();
          const typeLower = type?.toLowerCase() || "";
          
          // VAN: không có Indoor và Ultimum Lite
          const isVanAndBlocked =
            typeLower.includes("van") &&
            (name.includes("indoor") || name.includes("ultimum lite"));
          
          // Truck: không có SoftTec Indoor
          const isTruckAndBlocked =
            typeLower.includes("truck") && 
            name.includes("softtec") && 
            name.includes("indoor");

          if (isVanAndBlocked || isTruckAndBlocked) {
            gridItem.style.display = "none";
          } else {
            // Ensure item is visible if not blocked
            gridItem.style.display = "";
          }
        }
      });
    }

    changeCardMedia() {
      const template = document.querySelector(".js-products-images");
      if (!template) return;

      const allImages = template.content.cloneNode(true);
      const cardMedias = document.querySelectorAll(".js-card-media");
      const saved = localStorage.getItem("vehicleInfo");
      const currentPath = window.location.pathname;
      let type = null;

      const match = currentPath.match(/\/collections\/([^/]+)-covers/i);
      if (match && match[1]) {
        type = match[1];
      } else if (saved) {
        try {
          const parsed = JSON.parse(saved);
          type = parsed.type;
        } catch (err) {
          console.warn("Invalid vehicleInfo in localStorage");
        }
      }

      if (!type) return;

      if (type.includes("Cover")) {
        let splitType = type.split(" ");
        type = splitType[0];
      }
      const imageGroup = allImages.querySelector(
        `.js-${type.toLowerCase()}-group`
      );

      if (!imageGroup) return;

      const newImages = imageGroup.querySelectorAll("img");
      let imageIndex = 0;

      cardMedias.forEach((cardMedia) => {
        const cardInner = cardMedia.closest(".card__inner");
        const cardContent = cardInner?.nextElementSibling;
        const titleEl = cardContent?.querySelector(".js-collections-heading");
        if (!titleEl) return;

        const title =
          titleEl.dataset.originalText?.trim() || titleEl.textContent.trim();
        const lowerTitle = title.toLowerCase();
        const typeLower = type.toLowerCase();

        // VAN: không có Indoor và Ultimum Lite
        const isVanAndBlocked =
          typeLower.includes("van") &&
          (lowerTitle.includes("indoor") || lowerTitle.includes("ultimum lite"));

        // Truck: không có SoftTec Indoor
        const isTruckAndBlocked =
          typeLower.includes("truck") &&
          lowerTitle.includes("softtec") &&
          lowerTitle.includes("indoor");

        if (isVanAndBlocked || isTruckAndBlocked) {
          // Hide the card item if blocked
          const cardItem = cardMedia.closest("li");
          if (cardItem) {
            cardItem.style.display = "none";
          }
          return;
        }

        // Ensure card item is visible if not blocked
        const cardItem = cardMedia.closest("li");
        if (cardItem) {
          cardItem.style.display = "";
        }

        const img = cardMedia.querySelector("img");
        const newImg = newImages[imageIndex];

        if (img && newImg) {
          img.src = newImg.src;
          img.srcset = newImg.srcset;
          img.alt = newImg.alt;
          imageIndex++;
        }
      });
    }

    getVehicleType(year, make, model) {
      const yearData = YMM_DATA?.[year];
      if (!yearData) {
        console.warn(`[getVehicleType] No year data for year: ${year}`);
        return null;
      }

      const makeKey = this.normalizeKeyFromHandle(make);
      const modelKey = this.normalizeKeyFromHandle(model);
      
      // 🧹 Chuẩn hóa key để bỏ dấu, khoảng trắng, ký tự đặc biệt
      const normalize = (str) =>
        str?.toLowerCase().replace(/[^a-z0-9]/g, "") || "";

      // Tìm make key không phân biệt hoa thường
      const foundMakeKey = Object.keys(yearData).find((k) => {
        return normalize(k) === normalize(makeKey);
      });

      if (!foundMakeKey) {
        console.warn(`[getVehicleType] No make found for: ${makeKey} (normalized: ${normalize(makeKey)})`);
        console.warn(`[getVehicleType] Available makes in ${year}:`, Object.keys(yearData).slice(0, 10).join(', '), '...');
        return null;
      }

      const makeData = yearData[foundMakeKey];
      if (!makeData) return null;

      // Tìm model key không phân biệt hoa thường
      const foundModelKey = Object.keys(makeData).find((k) => {
        return normalize(k) === normalize(modelKey) || normalize(k).includes(normalize(modelKey));
      });

      if (!foundModelKey) {
        console.warn(`[getVehicleType] No model found for: ${modelKey} (normalized: ${normalize(modelKey)})`);
        console.warn(`[getVehicleType] Available models for ${foundMakeKey}:`, Object.keys(makeData).slice(0, 10).join(', '), '...');
        return null;
      }

      let type = makeData[foundModelKey]?.type || null;
      const bodyInfo = makeData[foundModelKey]?.body || "";

      const normalizeType = (str) => {
        if (!str) return str;
        const cleaned = str.replace(/cover/i, "").trim();
        return cleaned.charAt(0).toUpperCase() + cleaned.slice(1).toLowerCase();
      };

      const inferTypeFromBody = (bodyStr) => {
        if (!bodyStr) return null;
        const bodyLower = bodyStr.toLowerCase();
        if (bodyLower.includes("suv")) return "SUV";
        if (bodyLower.includes("truck") || bodyLower.includes("pickup")) return "Truck";
        if (bodyLower.includes("van")) return "Van";
        if (bodyLower.includes("wagon")) return "Wagon";
        if (bodyLower.includes("crossover")) return "SUV";
        if (bodyLower.includes("hatchback") || bodyLower.includes("sedan") || bodyLower.includes("coupe")) {
          return "Car";
        }
        return null;
      };

      const inferredFromBody = inferTypeFromBody(bodyInfo);

      if (inferredFromBody && (!type || type.toLowerCase() === "car" || type.toLowerCase() === "cover")) {
        console.log(
          `[getVehicleType] Overriding type ${type || "(none)"} with ${inferredFromBody} based on body info: ${bodyInfo}`
        );
        type = inferredFromBody;
      }

      type = normalizeType(type);

      if (type) {
        console.log(`[getVehicleType] Found type: ${type} for ${year} ${foundMakeKey} ${foundModelKey}`);
      }
      
      return type;
    }

    normalizeKeyFromHandle(str) {
      if (!str) return str;

      return str
        .split("-")
        .map((word) => {
          if (!isNaN(word)) return word.toUpperCase();
          return word.replace(/\b\w/g, (c) => c.toUpperCase());
        })
        .join(" ")
        .replace(/\bHd\b/, "HD");
    }

    clearLocalStorage() {
      localStorage.removeItem("vehicleInfo");
    }
  }

  customElements.define("vt-filter-model", FilterModal);
}
